import { Timestamp } from "firebase/firestore";
import getB from "../utils/bridges/EkaBridge";

export function convertDateToFirestoreTimestamp(date: Date) {
  return getB().firestore.Timestamp.fromDate(date);
}

export function isoStringToTimestamp(iso?: string | null) {
  if (!iso) {
    return;
  }

  return convertDateToFirestoreTimestamp(new Date(iso));
}

export function timestampToIsoString(timestamp?: Timestamp | null) {
  if (!timestamp) {
    return;
  }

  return timestamp.toDate().toISOString();
}

export function getDateFromTimeInMillisWithFallback(
  timeInMillis?: number | null
) {
  if (!timeInMillis) {
    return;
  }

  return new Date(timeInMillis).toISOString();
}
